var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthnicity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.933,
    height: 24.877,
    viewBox: "0 0 26.933 24.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348",
    transform: "translate(-1203.802 -223.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(1203.901 223.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6530",
    "data-name": "Path 6530",
    d: "M1219.1,236.009c.475,0,.951-.006,1.427,0a1.48,1.48,0,0,1,1.494,1.431c.026,1.014.021,2.029,0,3.042a1.527,1.527,0,0,1-.633,1.184.618.618,0,0,0-.214.418c-.022.75-.006,1.5-.012,2.252a1.48,1.48,0,0,1-1.634,1.624c-.4,0-.8.014-1.2-.013a1.428,1.428,0,0,1-1.341-1.408c-.014-.814.005-1.628-.014-2.441a.616.616,0,0,0-.2-.424,1.573,1.573,0,0,1-.656-1.287c-.009-.95-.015-1.9,0-2.853a1.5,1.5,0,0,1,1.558-1.526C1218.153,236,1218.629,236.009,1219.1,236.009Zm-1.049,6.9c0,.463,0,.926,0,1.389s.123.584.57.589c.3,0,.6,0,.9,0,.438-.006.56-.124.562-.555,0-.939.008-1.878,0-2.816a.589.589,0,0,1,.469-.669.481.481,0,0,0,.4-.546c0-.888.006-1.776,0-2.665,0-.412-.157-.55-.585-.551q-1.295-.006-2.59,0c-.43,0-.569.134-.572.554-.005.888,0,1.777,0,2.665a.473.473,0,0,0,.394.545.566.566,0,0,1,.462.634C1218.046,241.955,1218.056,242.431,1218.056,242.906Z",
    transform: "translate(-1202.238 -221.293)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6531",
    "data-name": "Path 6531",
    d: "M1212.967,236.009c.475,0,.952-.006,1.428,0a1.465,1.465,0,0,1,1.516,1.408c.04,1.037.024,2.078,0,3.117a1.277,1.277,0,0,1-.562,1.058.575.575,0,0,0-.295.618.65.65,0,0,1-.007.187.507.507,0,0,1-.538.469.484.484,0,0,1-.516-.488c-.02-.336-.009-.676-.005-1.013a.52.52,0,0,1,.457-.52.474.474,0,0,0,.392-.547c-.005-.89,0-1.778,0-2.668,0-.4-.141-.545-.54-.547q-1.335-.009-2.668,0c-.375,0-.533.149-.537.522-.011.915-.005,1.828,0,2.743a.445.445,0,0,0,.372.489.605.605,0,0,1,.495.689c-.012.927-.006,1.853,0,2.78,0,.458.118.574.577.578.3,0,.6.005.9,0,.424-.006.548-.135.553-.569,0-.25-.007-.5,0-.751a.514.514,0,0,1,.54-.544.5.5,0,0,1,.521.525c.012.363.017.728-.005,1.089a1.417,1.417,0,0,1-1.282,1.306,13,13,0,0,1-1.464.014,1.431,1.431,0,0,1-1.42-1.452c-.019-.8.007-1.6-.018-2.4a.685.685,0,0,0-.231-.447,1.569,1.569,0,0,1-.619-1.231q-.015-1.446,0-2.892a1.5,1.5,0,0,1,1.528-1.519C1212.015,236,1212.491,236.009,1212.967,236.009Z",
    transform: "translate(-1203.07 -221.293)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6532",
    "data-name": "Path 6532",
    d: "M1225.2,236.009c.489,0,.978-.008,1.466,0a1.48,1.48,0,0,1,1.468,1.46c.014.99.009,1.98,0,2.969a1.389,1.389,0,0,1-.612,1.188.508.508,0,0,0-.24.495c.011.739.007,1.479,0,2.218a1.494,1.494,0,0,1-1.61,1.62c-.389.006-.779.013-1.166-.007a1.443,1.443,0,0,1-1.414-1.461c-.012-.79-.009-1.579,0-2.369a.51.51,0,0,0-.244-.493,1.819,1.819,0,0,1-.568-2,.745.745,0,0,1,.521-.335.449.449,0,0,1,.489.425,3.777,3.777,0,0,1,.015.6.453.453,0,0,0,.379.518.588.588,0,0,1,.478.661c-.013.927-.006,1.855,0,2.782,0,.48.122.6.6.6.262,0,.526,0,.789,0,.545,0,.642-.094.643-.627,0-.877.01-1.755,0-2.631a.717.717,0,0,1,.542-.822.619.619,0,0,0,.32-.47c.03-.914.019-1.83.011-2.745a.461.461,0,0,0-.516-.509c-.9,0-1.805,0-2.707,0-.377,0-.523.152-.532.523-.005.276.007.552,0,.827a.536.536,0,1,1-1.068-.015c-.01-.324-.011-.651,0-.977a1.475,1.475,0,0,1,1.454-1.43C1224.2,236,1224.7,236.009,1225.2,236.009Z",
    transform: "translate(-1201.408 -221.293)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6533",
    "data-name": "Path 6533",
    d: "M1206.867,236.009c.476,0,.952-.006,1.429,0a1.551,1.551,0,0,1,1.472,2.013.746.746,0,0,1-.522.38c-.265.038-.45-.169-.507-.453-.054-.259-.037-.621-.2-.746a1.505,1.505,0,0,0-.823-.119c-.7-.013-1.4-.006-2.106,0-.49,0-.636.139-.637.615,0,.852,0,1.705,0,2.557a.522.522,0,0,0,.432.6c.356.08.447.355.445.689q-.008,1.371,0,2.744c0,.489.109.593.6.6q.415,0,.828,0c.482,0,.6-.12.606-.6.005-.889.016-1.779,0-2.669a.7.7,0,0,1,.541-.815.61.61,0,0,0,.3-.441,10.656,10.656,0,0,0,.017-1.088.536.536,0,1,1,1.068-.008c.01.414.01.828,0,1.241a1.34,1.34,0,0,1-.6,1.115.54.54,0,0,0-.254.527c.011.752.009,1.5,0,2.256a1.463,1.463,0,0,1-1.517,1.553c-.389.011-.778.012-1.166,0a1.473,1.473,0,0,1-1.508-1.532c-.011-.777.011-1.554-.013-2.33a.688.688,0,0,0-.225-.448,1.564,1.564,0,0,1-.614-1.232c0-.966-.009-1.931,0-2.9a1.49,1.49,0,0,1,1.532-1.512C1205.915,236,1206.391,236.009,1206.867,236.009Z",
    transform: "translate(-1203.901 -221.293)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6534",
    "data-name": "Path 6534",
    d: "M1221.212,233.744a2.139,2.139,0,1,1-4.278-.036,2.139,2.139,0,1,1,4.278.036Zm-2.153,1.05a1.069,1.069,0,1,0-1.04-1.1A1.06,1.06,0,0,0,1219.059,234.794Z",
    transform: "translate(-1202.273 -222.578)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    d: "M1212.97,231.581a2.144,2.144,0,0,1-.006,4.287,2.144,2.144,0,0,1,.006-4.287Zm1.054,2.146a1.064,1.064,0,0,0-1.067-1.071,1.069,1.069,0,0,0,0,2.138A1.059,1.059,0,0,0,1214.024,233.727Z",
    transform: "translate(-1203.036 -222.578)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6536",
    "data-name": "Path 6536",
    d: "M1204.726,233.726a2.12,2.12,0,0,1,2.132-2.146,2.144,2.144,0,1,1,0,4.288A2.111,2.111,0,0,1,1204.726,233.726Zm3.184-.007a1.053,1.053,0,0,0-1.071-1.062,1.069,1.069,0,0,0,.015,2.137A1.049,1.049,0,0,0,1207.91,233.719Z",
    transform: "translate(-1203.901 -222.578)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6537",
    "data-name": "Path 6537",
    d: "M1227.317,233.726a2.11,2.11,0,0,1-2.132,2.142,2.144,2.144,0,1,1,2.132-2.142Zm-3.184-.015a1.049,1.049,0,0,0,1.049,1.083,1.069,1.069,0,1,0-1.049-1.083Z",
    transform: "translate(-1201.408 -222.578)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6538",
    "data-name": "Path 6538",
    d: "M1212.939,226.274a2.141,2.141,0,0,1,2.166,2.006c.022.381-.144.627-.451.67-.331.046-.562-.156-.624-.543-.11-.695-.488-1.056-1.09-1.046-.576.011-.951.393-1.043,1.062a.536.536,0,0,1-.559.531c-.323-.013-.506-.236-.506-.616A2.13,2.13,0,0,1,1212.939,226.274Z",
    transform: "translate(-1203.036 -223.594)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6539",
    "data-name": "Path 6539",
    d: "M1219.131,226.275a2.126,2.126,0,0,1,2.079,2.051c0,.383-.175.609-.494.627s-.525-.183-.573-.556a1.056,1.056,0,0,0-1.066-1.036,1.043,1.043,0,0,0-1.059,1c-.063.427-.278.633-.618.593s-.5-.307-.459-.734A2.145,2.145,0,0,1,1219.131,226.275Z",
    transform: "translate(-1202.274 -223.594)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6540",
    "data-name": "Path 6540",
    d: "M1222.115,228.935a2.145,2.145,0,0,1,2.161,1.936.6.6,0,0,1-.43.724c-.348.064-.574-.125-.652-.548-.171-.92-.966-1.328-1.664-.851a1.115,1.115,0,0,0-.473.855c-.044.384-.242.571-.571.551-.313-.019-.5-.253-.5-.625A2.133,2.133,0,0,1,1222.115,228.935Z",
    transform: "translate(-1201.89 -222.97)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6541",
    "data-name": "Path 6541",
    d: "M1209.923,228.935a2.14,2.14,0,0,1,2.123,2.085.537.537,0,0,1-.692.564c-.263-.076-.346-.278-.382-.538a1.048,1.048,0,0,0-1.691-.816,1.738,1.738,0,0,0-.444.824c-.12.4-.279.587-.619.544-.312-.038-.494-.311-.465-.7A2.149,2.149,0,0,1,1209.923,228.935Z",
    transform: "translate(-1203.42 -222.97)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6542",
    "data-name": "Path 6542",
    d: "M1218.166,225.618a.561.561,0,0,1-.483.646c-.325.033-.553-.174-.6-.572a1.035,1.035,0,0,0-.786-.982.96.96,0,0,0-1.1.363,1.623,1.623,0,0,0-.234.616c-.079.393-.278.605-.6.576s-.519-.313-.481-.717a2.148,2.148,0,0,1,4.283.07Z",
    transform: "translate(-1202.654 -223.594)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6543",
    "data-name": "Path 6543",
    d: "M1218.17,231.014a.543.543,0,0,1-.5.588.511.511,0,0,1-.572-.513,1.116,1.116,0,0,0-.634-.987,1.063,1.063,0,0,0-1.481.757c-.015.074-.012.15-.025.224a.533.533,0,0,1-.608.517.556.556,0,0,1-.469-.653,2.149,2.149,0,0,1,4.293.067Z",
    transform: "translate(-1202.654 -222.972)",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthnicity);
export default __webpack_public_path__ + "static/media/ethnicity.fee08539cdc6cdff5bf251344a72e839.svg";
export { ForwardRef as ReactComponent };